import { render, staticRenderFns } from "./busbrand-add-or-update.vue?vue&type=template&id=ab073afa&scoped=true&"
import script from "./busbrand-add-or-update.vue?vue&type=script&lang=js&"
export * from "./busbrand-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./busbrand-add-or-update.vue?vue&type=style&index=0&id=ab073afa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab073afa",
  null
  
)

export default component.exports